// Threads the 8-day window of upcoming events from /api/events into
// the editor preview tree. Calendar blocks in 'auto' mode read this
// context to render pulled events; blocks in 'manual' mode ignore it.
//
// The window is `today` through `today + 7` (8 days inclusive),
// matches the newsletter cadence. Events with `hidden: true` are
// excluded server-side via `include_hidden=false` (the default).

import { createContext, useContext } from 'react';
import type { EventListItem } from '@shared/types';

export const UpcomingEventsContext = createContext<EventListItem[]>([]);

export function useUpcomingEvents(): EventListItem[] {
  return useContext(UpcomingEventsContext);
}
